export default "__VITE_ASSET__BOoaEtPE__"